import 'chartjs-plugin-datalabels';
import { FormatAsDollars } from '../../../utils/Helpers/Format';
import chunkString from '../../../utils/Helpers/chunkString';

const chartOptions = ({
  opts,
  rateValue,
  isLowest,
  yAxesLabel,
  savedLabel,
}) => {
  const isMobile = window.innerWidth < 768;

  return {
    maintainAspectRatio: isMobile ? false : true,
    responsive: true,
    aspectRatio: isMobile ? 1 : 1.9, 
    interaction: {
      mode: 'index',
      intersect: false,
    },
    layout: {
      padding: isMobile ? 0 : 20,
    },
    scales: {
      y: {
        display: true,
        stacked: true,
        grid: {
          display: true,
          color: 'rgba(102, 99, 102, 0.33)',
        },
        ticks: {
          callback: function (value) {
            if (value > 999 && isMobile) {
              return `$${(value / 1000).toFixed(0)}K`;
            }
            return `$${value.toFixed(0)}`;
          },
          font: {
            size: isMobile ? 14 : 16,
            family: 'Lato',
          },
          color: '#000000',
          padding: 15,
          maxTicksLimit: 6,
        },
        title: {
          display: true,
          text: yAxesLabel,
          font: {
            size: 14,
            weight: 800,
            family: 'Lato',
          },
          color: '#262626',
        },
      },
      x: {
        grid: {
          display: false,
          color: 'rgba(102, 99, 102, 0.33)',
        },
        stacked: true,
        ticks: {
          font: {
            size: isMobile ? 12 : 16,
            weight: 400,
            family: 'Lato',
          },
          color: '#262626',
          callback: function (value, index) {
            const label = this.getLabelForValue(value);
            if (typeof label === 'string' && label.includes('\n')) {
              return label.split('\n');
            }
            if (!isMobile || !Array.isArray(label)) return label;
            const maxLabelLength = isMobile ? 10 : 20;
            const newLabels = label.map((l) => chunkString(l, maxLabelLength));
            return newLabels.flat();
          },
        },
      },
    },
    plugins: {
      legend: {
        reverse: true,
        position: isMobile ? 'top' : 'bottom',
        onClick: function (e) {
          e.stopPropagation();
        },
        labels: {
          font: {
            size: isMobile ? 14 : 16,
            family: 'Lato',
          },
          color: '#262626',
          padding: isMobile ? 5 : 20,
          boxWidth: 20,
        },
      },
      tooltip: {
        mode: 'index',
        callbacks: {
          label: function (context) {
            const value = FormatAsDollars(context.parsed.y);
            const label = context.dataset.label || '';
            return ` ${label}: ${value}`;
          },
          title: function (tooltipItems) {
            const total = tooltipItems.reduce(function (acc, item) {
              return acc + item.parsed.y;
            }, 0);
            const xLabel = tooltipItems[0].label;
            const labelArray = Array.isArray(xLabel) ? xLabel : [xLabel];
            return `${labelArray.join(' ')}: ${FormatAsDollars(total)}`;
          },
        },
      },
      datalabels: {
        formatter: (value, ctx) => {
          if (ctx.datasetIndex !== ctx.chart.data.datasets.length - 1)
            return '';
          return ctx.dataIndex === 0
            ? isLowest
              ? `${FormatAsDollars(rateValue.toFixed(0))} ${savedLabel}`
              : ''
            : opts[ctx.dataIndex].savings && opts[ctx.dataIndex].savings > 0
              ? `${FormatAsDollars(
                  opts[ctx.dataIndex].savings.toFixed(0)
                )} ${savedLabel}`
              : '';
        },
        align: 'end',
        anchor: 'end',
        color: (ctx) => {
          return '#000000';
        },
        font: {
          weight: isMobile ? 400 : 800,
          size: isMobile ? 10 : 16,
          lineHeight: 1.2,
          family: 'Lato',
        },
      },
    },
  };
};

export default chartOptions;
